import {
  ACCOUNT_ACTIVATION_CANCEL,
  ACCOUNT_ACTIVATION_ERROR,
  ACCOUNT_ACTIVATION_INIT,
  ACCOUNT_ACTIVATION_RECEIVE,
  ACCOUNT_ACTIVATION_REQUEST,
  ACCOUNT_ACTIVATION_VALIDATION_ERROR,
  EDIT_PHONE_NUMBER,
  EDIT_PHONE_NUMBER_CONFIRMATION,
  PASSWORD_RENEWAL_ERROR,
  PASSWORD_RENEWAL_MODAL_VISIBILITY,
  PASSWORD_RENEWAL_RECEIVE,
  PASSWORD_RENEWAL_REQUEST,
  PHONE_NUMBER_VALIDATION_ERROR,
  RESET_PHONE_NUMBER_VALIDATION_ERRORS,
} from './actions';

export const initialState = {
  phoneNumber: {
    changed: false,
    originalValue: '',
    currentValue: '',
    confirmValue: '',
    errors: {
      phone: [],
      phoneConfirm: [],
    },
  },
  activation: {
    initialized: false,
    isFetching: false,
    data: null,
    error: null,
  },
  passwordRenewal: {
    modalVisible: false,
    isFetching: false,
  },
};

const activationReducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case ACCOUNT_ACTIVATION_INIT: {
      return {
        ...state,
        initialized: true,
      };
    }
    case ACCOUNT_ACTIVATION_CANCEL: {
      return {
        ...state,
        initialized: false,
        error: null,
      };
    }
    case ACCOUNT_ACTIVATION_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    // intentional fallthroughs
    case ACCOUNT_ACTIVATION_RECEIVE:
    case ACCOUNT_ACTIVATION_ERROR: {
      return {
        ...state,
        isFetching: false,
        ...payload,
      };
    }
    default:
      return state;
  }
};

const phoneNumberReducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case ACCOUNT_ACTIVATION_INIT: {
      return {
        ...state,
        currentValue: payload.originalValue,
        originalValue: payload.originalValue,
      };
    }
    case ACCOUNT_ACTIVATION_CANCEL: {
      return initialState.phoneNumber;
    }
    case EDIT_PHONE_NUMBER: {
      return {
        ...state,
        changed: true,
        currentValue: payload.currentValue,
      };
    }
    case EDIT_PHONE_NUMBER_CONFIRMATION: {
      return {
        ...state,
        ...payload,
      };
    }
    case PHONE_NUMBER_VALIDATION_ERROR: {
      return {
        ...state,
        ...payload,
      };
    }
    case RESET_PHONE_NUMBER_VALIDATION_ERRORS: {
      return {
        ...state,
        errors: initialState.phoneNumber.errors,
      };
    }
    default:
      return state;
  }
};

const passwordRenewalReducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case PASSWORD_RENEWAL_MODAL_VISIBILITY: {
      return {
        ...state,
        ...payload,
      };
    }
    case PASSWORD_RENEWAL_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case PASSWORD_RENEWAL_RECEIVE: {
      return {
        ...state,
        isFetching: false,
        ...payload,
      };
    }
    case PASSWORD_RENEWAL_ERROR: {
      return {
        ...state,
        isFetching: false,
        ...payload,
      };
    }
    default:
      return state;
  }
};

export const reducer = (state = initialState, action) => {
  return {
    phoneNumber: phoneNumberReducer(state.phoneNumber, action),
    activation: activationReducer(state.activation, action),
    passwordRenewal: passwordRenewalReducer(state.passwordRenewal, action),
  };
};
